/* eslint-disable no-console */

import Raven from "raven-js";

import { RAVEN_DSN, IS_PROD } from "config/constants";

export default class Log {
  static setup() {
    if (IS_PROD && !Raven.isSetup()) {
      Raven.config(RAVEN_DSN, {
        environment: process.env.ENV,
        release: process.env.RELEASE,
      }).install();
    }
  }

  /**
   * Log an error to Sentry
   * @param {*} msg - Error message or instance
   * @param {String} level - severity
   * @param {Object} extra - supplemental data to pass to Raven
   * @param {Boolean} toConsole - true if this error should be logged to the console as well.
   * @param {Array<String>} fingerprint - see https://docs.sentry.io/learn/rollups/#customize-grouping-with-fingerprints
   */
  static logger(msg, level, extra, toConsole = true, fingerprint) {
    if (IS_PROD) {
      this.setup();
      Raven.captureException(msg, {
        level,
        fingerprint,
        extra: {
          ...extra,
          ...msg.context, // API errors return a special kind of error with lots of context
        },
      });
    }

    if (toConsole) {
      switch(level) {
        case "error":
          console.error(msg);
          break;
        case "warning":
          console.warn(msg);
          break;
        default:
          console.log(msg);
      }
    }
  }

  static error(err) {
    this.logger(err, "error");
  }

  static warn(msg) {
    this.logger(msg, "warning");
  }

  static log(msg) {
    this.logger(msg, "info");
  }

  static context(fn) {
    if (IS_PROD) {
      this.setup();
      return Raven.context(fn);
    }
  }
}
